import { useState } from 'react'
import {
	EuiButton,
	EuiButtonEmpty,
	EuiFlexGroup,
	EuiFlexItem,
	EuiModalBody,
	EuiModalFooter,
	EuiText
} from '@equipmentshare/ds2'
import useDeleteItemHandler from '../../effects/delete-item'
import { heapEvent } from '@equipmentshare/heaper'

export type Props = {
  item: {id: number, quantity: number},
	onCancel: () => void,
	onSuccess: () => void,
}

export default function DeleteItem( { item, onCancel, onSuccess }: Props ) {
	const deleteItem = useDeleteItemHandler()
	const [ isSaving, setIsSaving ] = useState( false )

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Delete Item Modal - Click - Submit', {} )
		setIsSaving( true )

		try {
			await deleteItem( item.id )
			 onSuccess()
		} catch ( e: unknown ) {
			// Handle error if needed
		} finally {
			setIsSaving( false )
		}
	}

	const handleCancel = () => {
		// heapEvent( 'Inventory - Delete Item Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<>
			<EuiModalBody>
				<EuiFlexGroup direction="column">
					<EuiFlexItem>
						<EuiText>
              To delete an item from your inventory, quantity needs to be 0. To adjust your
              quantity, use <span style={{ fontWeight: 'bold' }}>Edit quantity</span>.
						</EuiText>
					</EuiFlexItem>
					<EuiFlexItem>
						<EuiText>
              Current Qty: <span style={{ fontWeight: 'bold' }}>{item.quantity}</span>
						</EuiText>
					</EuiFlexItem>

				</EuiFlexGroup>

			</EuiModalBody>

			<EuiModalFooter>
				<EuiButtonEmpty
					id="cancelBtn"
					color="text"
					onClick={handleCancel}
				>
          Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					color="danger"
					className="submit"
					onClick={handleSubmit}
					isLoading={isSaving}
					disabled={item.quantity !== 0}
				>
          Delete item
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
